
import './App.css';
import { SearchStatusParticipant } from './Components/SearchStatusParticipant';

function App() {
  return (
    <div className="App">
      <SearchStatusParticipant />
    </div>
  );
}

export default App;
